import React from "react";
import "./ContactForm.css";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaWhatsapp,
  FaMapMarkerAlt,
  FaClock,
} from "react-icons/fa";
import pulsojetpacking from "../../assets/images/pulsojetbox.png";

const ContactForm = () => {
  const whatsappMessage =
    "https://wa.me/919910652055?text=I'm%20interested%20in%20your%20products."; // Pre-filled message

  return (
    <>
      {/* Contact Section */}
      <section className="contact-section">
        <div className="contact-wrapper">
          {/* Left Column */}
          <div className="contact-left">
            <h2>Need Help? Let’s Talk.</h2>
            <p>We’re just a tap away — no waiting, no form-filling.</p>

            {/* Contact Info */}
            <div className="contact-details">
              <p>
                <FaPhoneAlt /> <strong>Call Us:</strong> <br />
                <a href="tel:+919910652055">+91 99106 52055</a>
              </p>
              <p>
                <FaWhatsapp /> <strong>WhatsApp Chat:</strong> <br />
                <a
                  href={whatsappMessage}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Start a Chat Now (Talk to our product advisor)
                </a>
              </p>
              <p>
                <FaEnvelope /> <strong>Email Us:</strong> <br />
                <a href="mailto:sales@sabiote.in">sales@sabiote.in</a> <br />
                <small>We typically reply within 12 working hours</small>
              </p>
              <p>
                <FaClock /> <strong>Working Hours:</strong> <br />
                <small>Mon–Sat: 9 AM – 6 PM</small>
              </p>
              <p>
                <FaMapMarkerAlt /> <strong>Visit Us:</strong>
                <br />
                <small>
                  B-23, First Floor, DDA SHED, Okhla Industrial Area, Phase 2.
                  New Delhi-110020
                </small>
                <br />
                <a
                  href="https://www.google.com/maps?q=B-23,+First+Floor,+DDA+SHED,+Okhla+Industrial+Area,+Phase+2,+New+Delhi-110020"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Open in Google Maps
                </a>
              </p>
            </div>
          </div>

          {/* Right Column */}
          <div className="contact-right compact-contact-right">
            <h3>Quick Contact</h3>
            <img
              src={pulsojetpacking}
              alt="PulsOjet® packaging"
              className="top-image-pulso-packet"
            />
            <img
              src={pulsojetpacking}
              alt="PulsOjet® packaging"
              className="bottom-image-pulso-packet"
            />
            <a
              href={whatsappMessage}
              target="_blank"
              rel="noopener noreferrer"
              className="callback-btn"
            >
              <FaWhatsapp /> Book a Callback
            </a>
          </div>
        </div>

        {/* Floating WhatsApp Icon */}
        <a
          href={whatsappMessage}
          target="_blank"
          rel="noopener noreferrer"
          className="whatsapp-float"
        >
          <FaWhatsapp size={28} />
        </a>
      </section>
    </>
  );
};

export default ContactForm;
